import { useNavigate } from "react-router-dom";
import CustomBtn from "../CustomBtn";

const Quiz = () => {
    const navigate = useNavigate();

  return (
    <div className="w-full max-w-[500px] mx-auto px-4">
      {/* Заголовок */}
      <div className="flex flex-col items-center w-full">
        <h1 className="text-4xl w-full  text-center font-medium bg-gradient-to-r from-[#FC5EB2] to-[#444CE7] mb-4 bg-clip-text text-transparent">
          Transform your skincare with<br /> expert guidance
        </h1>
        <p className="text-xs sm:text-sm text-center mb-5 px-2">
          Take our short cosmetologist quiz and unlock a customized skincare
          plan built on ingredient analysis and your needs.
        </p>
      </div>

      {/* Телефоны */}
      <div className="relative w-full h-[70vw] max-h-[320px] rounded-b-3xl overflow-hidden">
        {/* Левый телефон */}

        <img
        loading="lazy"
          className="absolute bottom-[5%] left-[6%] w-[250px] sm:w-[300px] z-20"
          src="/iPhQuizLeft.webp"
          alt="IphLeft"
        />

        <img
        loading="lazy"
          className="absolute bottom-[7%] left-[32%] w-[250px] sm:w-[300px] z-10"
          src="/iPhQuizRight.webp"
          alt="IphRight"
        />


        {/* Градиент снизу */}
        <div className="absolute bottom-0 left-0 z-30 w-full h-6 bg-gradient-to-t from-white to-transparent backdrop-blur-md"></div>
      </div>

      {/* Кнопка */}
      <div className="px-2 mt-4">
        <CustomBtn
          text={"Get My Plan"}
          handleClick={() => navigate("/loading")}
          isSelected={false}
        />
      </div>
    </div>
  );
};
export default Quiz;
